import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAxiosInstance();
    const getParams = (key) => {
      if (params?.[key] === "status") {
        return `${key}=${parseInt(params[key])}&`;
      } else if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };
    try {
      const response = await api[method](
        `${endpoint}?${getParams("_id")}${getParams("status")}${getParams(
          "sort_by"
        )}sort_order=${params?.sort_order || ""}&page_size=${
          params?.page_size || "10"
        }&${getParams("search")}&page=${params?.page || 1}&${getParams(
          "length"
        )}`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err.response?.data || err.message,
      }; 
    }
  };

export const category = createApi({
  reducerPath: "categoryApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Category"],
  endpoints: (builder) => ({
    getCategoryListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/category/list`,
      }),
      provideTags: ["Category"],
    }),
    getCategoryFormDataById: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/category/edit`,
      }),
      provideTags: ["Category"],
    }),
    updateCategoryListData: builder.mutation({
        query: (body) => ({
          method: "post",
          body,
          endpoint: `/admin/category/update`,
        }),
  
        invalidatesTags: ["Category"],
      }),
    deleteCategoryData: builder.mutation({
      query: (values) => ({
        method: "delete",
        params: values,
        endpoint: `/admin/category/delete`,
      }),

      invalidatesTags: ["Category"],
    }),
    getFilterListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/filters/common-search-filters`,
      }),
    }),
    statusChange: builder.mutation({
      query: (values) => ({
        method: "post",
        params: values,
        endpoint: `/admin/category/status-change`,
      }),
    }),
  }),
});

export const {
  useGetCategoryListDataQuery,
  useGetCategoryFormDataByIdQuery,
  useUpdateCategoryListDataMutation,
  useDeleteCategoryDataMutation,
  useGetFilterListDataQuery,
  useStatusChangeMutation,
} = category;
